import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import {OmContainer} from './OmContainer';
import { MblStatusViewModel } from './MblStatusViewModel';
import { FileLockProp, InvoiceBillCrdb, RelatedCrdbDefinition } from '../ifmsTypes';
import {OiHbl} from './OiHbl';
import { appendLine } from '../util';
import { CrDbHd } from './CrDbHd';
import _ from 'lodash';

export class OiMbl extends TrackableEntity {
    id: number = 0;
    directBl: boolean = false;
    modelName:string = "oimbl"; //for ifmsButton > getChangedListData

    shipmentType: string = '';
    refNo: string = '';
    branch: string = '';
    lotNo: string = '';
    svccNo: string = '';
    agentRefNo: string = '';
    agent: number = 0;
    agentName: string = '';
    agent2: number = 0;
    agent2Name: string = '';
    agent3: number = 0;
    agent3Name: string = '';
    mblCustomer: number = 0;
    mblCustomerName: string = '';
    carrier: number = 0;
    carrierName: string = '';
    mblNo: string = '';
    sMblNo: string = '';
    mCommodity: string = '';
    steamShip: number = 0;
    steamShipName: string = '';
    vessel: string = '';
    voyage: string = '';
    vesselFlag: string = '';
    country: string = '';
    feederVessel: string = '';
    cyLocation: number = 0;
    cyLocationName: string = '';
    cfsLocation: number = 0;
    cfsLocationName: string = '';
    emptyRtn: number = 0;
    emptyRtnName: string = '';
    oimContainerList: OmContainer[] = [];
    unlCode: string = '';
    uslCode: string = '';
    eta: string | null = null;
    loadingPort: string = '';
    undCode: string = '';
    usdCode: string = '';
    etd: string | null = null;
    discharge: string = '';
    unfCode: string = '';
    usfCode: string = '';
    fEta: string | null = null;
    finalDest: string = '';
    finalDestName: string = '';
    itNo: string = '';
    itDate: string | null = null;
    itPlace: string = '';
    ppcc: string = '';
    lclfcl: string = '';
    moveType: string = '';
    msManId: string = '';
    ebl: boolean = false;
    expRls: boolean = false;
    rlsDate: string | null = null;
    line: string = '';
    fileClosed: number = 0;
    isClosed: boolean = false;
    closedBy: string = '';
    closeDate: string | null = null;
    actClosed: boolean = false;
    actClosedBy: string = '';
    actCloseDate: string | null = null;
    manifestFrom: string = '';
    toAgent: string = '';
    cargoNo: string = '';
    dutyCustomer: number = 0;
    dutyCustomerName: string = '';
    dutyAgent: number = 0;
    dutyAgentName: string = '';
    profitShare: number = 0;
    cur1: string = '';
    cur2: string = '';
    exRate1: number = 0;
    exRate2: number = 0;
    oFrtCfrm: boolean = false;
    oFrtHold: boolean = false;
    completeInvo: boolean = false;
    completeBill: boolean = false;
    completeCrDb: boolean = false;
    confirmDate: string | null = null;
    confirmedBy: string = '';
    confirmActionDate: string | null = null;
    agentCreditHold: boolean = false;
    hblCount: number = 0;
    postDate: string | null = null;
    statusInvo: string = '';
    statusBill: string = '';
    statusCrDb: string = '';
    u1Id: string = '';
    u1Date: string | null = null;
    u2Id: string = '';
    u2Date: string | null = null;
    pimsLinkUserId: string = '';
    pimsLinkId: number = 0;
    pimsLinkDate: string | null = null;
    amsLinkUserId: string = '';
    amsLinkId: number = 0;
    amsLinkDate: string | null = null;
    itCarrier: number = 0;
    itClass: string = '';
    showAgent: string = '';
    devanRemark: string = '';
    oblDate: string | null = null;
    pnlDate: string | null = null;
    operator: string = '';
    agentPimsId: number = 0;
    aaid: number = 0;
    cyAddress: string = '';
    cfsAddress: string = '';
    cyContact: string = '';
    cfsContact: string = '';

    //Direct B/L
    shipper: number = 0;
    consignee: number = 0;
    notify: number = 0;
    broker: number = 0;
    sName : string = '';
    cName: string = '';
    nName: string= '';
    bName: string = '';
    shipperName: string = '';
    consigneeName: string = '';
    notifyName: string = '';
    brokerName: string = '';
    bTel: string = '';
    bFax: string = '';
    bContact: string= '';
    bEmail: string = '';
    finalDest2: string='';
    fEta2: string | null = null;
    amsblNo: string = '';
    opeartor: string = '';
    custRefNo: string='';
    mark: string ='';
    description: string = '';
    markPkg: string = '';
    markGross: string ='';
    markMeasure: string = '';
    multinameId: number = 0;


    // cloud
    mblCustomer2: number = 0;
    mblCustomer2Name: string = '';
    rlsDateBy: string = '';
    rcvCrDbBy: string = '';
    oblDateBy: string = '';
    projectNo: string = '';
    hblList: OiHbl[] = [];
    arrivedCFSDate: string | null = null;
    devanDate: string | null = null;
    // frontend only

    // ISalesCostParent.invoiceBill
    invoiceBill:InvoiceBillCrdb|null = null;
    // ISalesCostParent.invoiceBill
    readonlyCrdbLineItems?: Array<CrDbHd>|null = null;                   // no track
    relatedCrdbDefinitions: Array<RelatedCrdbDefinition>|null = null;

    milestone: MblStatusViewModel|null = null;
    milestoneContainerSelectedIndex: number = 0;

    trStatus: string = '';

    chbRspCode: string = '';
    chbRspMsg: string = '';

    get canChangeBranch():boolean {
        if (this.id <= 0) {
            return true;
        }

        const allowedStatuses = ['', 'E', 'D'];
        return allowedStatuses.includes(this.statusBill) &&
            allowedStatuses.includes(this.statusInvo) &&
            allowedStatuses.includes(this.statusCrDb) &&
            this.hblList.every(h => allowedStatuses.includes(h.statusBill) && allowedStatuses.includes(h.statusInvo) && allowedStatuses.includes(h.statusCrDb))
    };

    static fileLockEnableProps: FileLockProp[] = [
        { key: 'cyLocation', name: 'CY Location' },
        { key: 'itNo', name: 'I.T #' },
        { key: 'itPlace', name: 'I.T Place' },
        { key: 'oimContainerList.lastFreeDay', name: 'Container Info Last Free Day' },
        { key: 'oimContainerList.goDate', name: 'Container Info Last G.O Date' },
        { key: 'oimContainerList.pickupNo', name: 'Container Info Pickup #' },
        { key: 'oimContainerList.pickupLoc', name: 'Container Info Pickup Location' },
    ];

    constructor(init?:Partial<OiMbl>) {
        super();
        this.key='id';
        Object.assign(this, init);        
        this.noTrackProps.push('id', 'agent2Name', 'agent3Name', 'isClosed', 'dutyCustomerName', 'dutyAgentName', 'agentCreditHold', 'hblCount',
        'closedDate', 'invoiceBill', 'readonlyCrdbLineItems', 'isLockCur1', 'isLockCur2', 'isLockCur3', 'isLockCur4', 
        //'milestone', 
        'canChangeBranch', 'hblList', 'actClosed', 'actClosedBy', 'actCloseDate', 'confirmDate', 'confirmedBy', 'trStatus');
        this.getdateProps.push('u1Date', 'u2Date'); 
        if(this.id === 0) this.id = this.GetNextId();
        
        if(this.oimContainerList.length > 0) {
            this.oimContainerList = this.oimContainerList.map(d => new OmContainer(d));
        } else {
            this.oimContainerList = [];
        }
    }

    isFileLockFor(propName: string) {
        return this.isClosed && !OiMbl.fileLockEnableProps.some(x => x.key === propName);
    }

    static getFileLockMessage(): string {
        const messageBase = appendLine("OP Close", "The following fields are editable only:\n")
        return appendLine(messageBase, OiMbl.fileLockEnableProps
            .map(x => x.name)
            .reduce((acc: string, x) => appendLine(acc, `${x}`), ""));
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        const dicFieldMap:IDictionary<DBMappingInfo> = {};
        _.keys(OiMbl.dicFieldMappings).forEach(m=>{
            dicFieldMap[m] = OiMbl.dicFieldMappings[m];
        });

        _.keys(OmContainer.dicFieldMappings4Import).forEach(m=>{
            dicFieldMap[`oimContainerList.${m}`] = OmContainer.dicFieldMappings4Import[m];
        });
        return dicFieldMap;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_OIMMAIN' }),
        'directBl': new DBMappingInfo({ field: 'F_DirectBL', table: 'T_OIMMAIN' }),
        'shipmentType': new DBMappingInfo({ field: 'F_ShipmentType', table: 'T_OIMMAIN' }),
        'refNo': new DBMappingInfo({ field: 'F_RefNo', table: 'T_OIMMAIN' }),
        'branch': new DBMappingInfo({ field: 'F_Branch', table: 'T_OIMMAIN' }),
        'lotNo': new DBMappingInfo({ field: 'F_LotNo', table: 'T_OIMMAIN' }),
        'svccNo': new DBMappingInfo({ field: 'F_SvccNo', table: 'T_OIMMAIN' }),
        'agentRefNo': new DBMappingInfo({ field: 'F_AgentRefNo', table: 'T_OIMMAIN' }),
        'agent': new DBMappingInfo({ field: 'F_Agent', table: 'T_OIMMAIN' }),
        'agent2': new DBMappingInfo({ field: 'F_Agent2', table: 'T_OIMMAIN' }),
        'agent3': new DBMappingInfo({ field: 'F_Agent3', table: 'T_OIMMAIN' }),
        'mblCustomer': new DBMappingInfo({ field: 'F_MBLCustomer', table: 'T_OIMMAIN' }),
        'carrier': new DBMappingInfo({ field: 'F_Carrier', table: 'T_OIMMAIN' }),
        'mblNo': new DBMappingInfo({ field: 'F_MblNo', table: 'T_OIMMAIN' }),
        'sMblNo': new DBMappingInfo({ field: 'F_SMblNo', table: 'T_OIMMAIN' }),
        'mCommodity': new DBMappingInfo({ field: 'F_MCommodity', table: 'T_OIMMAIN' }),
        'steamShip': new DBMappingInfo({ field: 'F_SteamShip', table: 'T_OIMMAIN' }),
        'vessel': new DBMappingInfo({ field: 'F_Vessel', table: 'T_OIMMAIN' }),
        'voyage': new DBMappingInfo({ field: 'F_Voyage', table: 'T_OIMMAIN' }),
        'vesselFlag': new DBMappingInfo({ field: 'F_VesselFlag', table: 'T_OIMMAIN' }),
        'country': new DBMappingInfo({ field: 'F_Country', table: 'T_OIMMAIN' }),
        'feederVessel': new DBMappingInfo({ field: 'F_FeederVessel', table: 'T_OIMMAIN' }),
        'cyLocation': new DBMappingInfo({ field: 'F_CYLocation', table: 'T_OIMMAIN' }),
        'cfsLocation': new DBMappingInfo({ field: 'F_CFSLocation', table: 'T_OIMMAIN' }),
        'emptyRtn': new DBMappingInfo({ field: 'F_EmptyRtn', table: 'T_OIMMAIN' }),
        'unlCode': new DBMappingInfo({ field: 'F_UNLCode', table: 'T_OIMMAIN' }),
        'uslCode': new DBMappingInfo({ field: 'F_USLCode', table: 'T_OIMMAIN' }),
        'eta': new DBMappingInfo({ field: 'F_ETA', table: 'T_OIMMAIN' }),
        'loadingPort': new DBMappingInfo({ field: 'F_LoadingPort', table: 'T_OIMMAIN' }),
        'undCode': new DBMappingInfo({ field: 'F_UNDCode', table: 'T_OIMMAIN' }),
        'usdCode': new DBMappingInfo({ field: 'F_USDCode', table: 'T_OIMMAIN' }),
        'etd': new DBMappingInfo({ field: 'F_ETD', table: 'T_OIMMAIN' }),
        'discharge': new DBMappingInfo({ field: 'F_Discharge', table: 'T_OIMMAIN' }),
        'unfCode': new DBMappingInfo({ field: 'F_UNFCode', table: 'T_OIMMAIN' }),
        'usfCode': new DBMappingInfo({ field: 'F_USFCode', table: 'T_OIMMAIN' }),
        'fEta': new DBMappingInfo({ field: 'F_FETA', table: 'T_OIMMAIN' }),
        'finalDest': new DBMappingInfo({ field: 'F_FinalDest', table: 'T_OIMMAIN' }),
        'itNo': new DBMappingInfo({ field: 'F_ITNo', table: 'T_OIMMAIN' }),
        'itDate': new DBMappingInfo({ field: 'F_ITDate', table: 'T_OIMMAIN' }),
        'itPlace': new DBMappingInfo({ field: 'F_ITPlace', table: 'T_OIMMAIN' }),
        'ppcc': new DBMappingInfo({ field: 'F_PPCC', table: 'T_OIMMAIN' }),
        'lclfcl': new DBMappingInfo({ field: 'F_LCLFCL', table: 'T_OIMMAIN' }),
        'moveType': new DBMappingInfo({ field: 'F_MoveType', table: 'T_OIMMAIN' }),
        'msManId': new DBMappingInfo({ field: 'F_MSManId', table: 'T_OIMMAIN' }),
        'ebl': new DBMappingInfo({ field: 'F_EBL', table: 'T_OIMMAIN' }),
        'expRls': new DBMappingInfo({ field: 'F_ExpRls', table: 'T_OIMMAIN' }),
        'rlsDate': new DBMappingInfo({ field: 'F_RlsDate', table: 'T_OIMMAIN' }),
        'line': new DBMappingInfo({ field: 'F_Line', table: 'T_OIMMAIN' }),
        'closedBy': new DBMappingInfo({ field: 'F_ClosedBy', table: 'T_OIMMAIN' }),
        'manifestFrom': new DBMappingInfo({ field: 'F_ManifestFrom', table: 'T_OIMMAIN' }),
        'toAgent': new DBMappingInfo({ field: 'F_ToAgent', table: 'T_OIMMAIN' }),
        'cargoNo': new DBMappingInfo({ field: 'F_CargoNo', table: 'T_OIMMAIN' }),
        'postDate': new DBMappingInfo({ field: 'F_PostDate', table: 'T_OIMMAIN' }),
        'dutyCustomer': new DBMappingInfo({ field: 'F_DutyCustomer', table: 'T_OIMMAIN' }),
        'dutyAgent': new DBMappingInfo({ field: 'F_DutyAgent', table: 'T_OIMMAIN' }),
        'cur1': new DBMappingInfo({ field: 'F_Cur1', table: 'T_OIMMAIN' }),
        'cur2': new DBMappingInfo({ field: 'F_Cur2', table: 'T_OIMMAIN' }),
        'exRate1': new DBMappingInfo({ field: 'F_EXRATE1', table: 'T_OIMMAIN' }),
        'exRate2': new DBMappingInfo({ field: 'F_EXRATE2', table: 'T_OIMMAIN' }),
        'profitShare': new DBMappingInfo({ field: 'F_ProfitShare', table: 'T_OIMMAIN' }),
        'oFrtCfrm': new DBMappingInfo({ field: 'F_OfrtCfrm', table: 'T_OIMMAIN' }),
        'oFrtHold': new DBMappingInfo({ field: 'F_OfrtHold', table: 'T_OIMMAIN' }),
        'u1Id': new DBMappingInfo({ field: 'F_U1ID', table: 'T_OIMMAIN' }),
        'u1Date': new DBMappingInfo({ field: 'F_U1Date', table: 'T_OIMMAIN' }),
        'u2Id': new DBMappingInfo({ field: 'F_U2ID', table: 'T_OIMMAIN' }),
        'u2Date': new DBMappingInfo({ field: 'F_U2Date', table: 'T_OIMMAIN' }),
        'mblCustomer2': new DBMappingInfo({ field: 'mblcustomer2', table: 'T_OIMMAIN' }),
        'rlsDateBy': new DBMappingInfo({ field: 'rlsby', table: 'T_OIMMAIN' }),
        'rcvCrDbBy': new DBMappingInfo({ field: 'RcvCrDbBy', table: 'T_OIMMAIN' }),
        'oblDate': new DBMappingInfo({ field: 'F_OblDate', table: 'T_OIMMAIN' }),
        'oblDateBy': new DBMappingInfo({ field: 'OblDateBy', table: 'T_OIMMAIN' }),
        'pnlDate': new DBMappingInfo({ field: 'F_PnlDate', table: 'T_OIMMAIN' }),
        'projectNo': new DBMappingInfo({ field: 'ProjectNo', table: 'T_OIMMAIN' }),
        'arrivedCFSDate': new DBMappingInfo({ field: 'F_ArrivedCFSDate', table: 'T_OIMMAIN' }),
        'devanDate': new DBMappingInfo({ field: 'F_DevanDate', table: 'T_OIMMAIN' }),
        //Direct B/L
        'shipper': new DBMappingInfo({field:'f_mshipper', table: 'T_OIMMAIN'}),
        'consignee': new DBMappingInfo({field:'f_mconsignee', table: 'T_OIMMAIN'}),
        'notify': new DBMappingInfo({field:'f_mnotify', table: 'T_OIMMAIN'}),
        'broker': new DBMappingInfo({field:'f_mbroker', table: 'T_OIMMAIN'}),
        'sName': new DBMappingInfo({field:'f_msname', table: 'T_OIMMAIN'}),
        'cName': new DBMappingInfo({field:'f_mcname', table: 'T_OIMMAIN'}),
        'nName': new DBMappingInfo({field:'f_mnname', table: 'T_OIMMAIN'}),
        'bName': new DBMappingInfo({field:'f_mbname', table: 'T_OIMMAIN'}),
        'bTel': new DBMappingInfo({field:'f_mbtel', table: 'T_OIMMAIN'}),
        'bFax': new DBMappingInfo({field:'f_mbfax', table: 'T_OIMMAIN'}),
        'bContact': new DBMappingInfo({field:'f_mbcontact', table: 'T_OIMMAIN'}),
        'bEmail': new DBMappingInfo({field:'f_mbemail', table: 'T_OIMMAIN'}),
        'finalDest2': new DBMappingInfo({field:'f_mfinaldest', table: 'T_OIMMAIN'}),
        'fEta2': new DBMappingInfo({field:'f_mfeta', table: 'T_OIMMAIN'}),
        'amsblNo': new DBMappingInfo({field:'f_mamsblno', table: 'T_OIMMAIN'}),
        'opeartor': new DBMappingInfo({field:'f_operator', table: 'T_OIMMAIN'}),
        'custRefNo': new DBMappingInfo({field:'f_mcustrefno', table: 'T_OIMMAIN'}),
        'mark': new DBMappingInfo({field:'f_mmark', table: 'T_OIMMAIN'}),
        'description': new DBMappingInfo({field:'f_mdescription', table: 'T_OIMMAIN'}),
        'markPkg': new DBMappingInfo({field:'f_mmarkpkg', table: 'T_OIMMAIN'}),
        'markGross': new DBMappingInfo({field:'f_mmarkgross', table: 'T_OIMMAIN'}),
        'markMeasure': new DBMappingInfo({field:'f_mmarkmeasure', table: 'T_OIMMAIN'}),
        'multinameId': new DBMappingInfo({field:'f_mmultinameid', table: 'T_OIMMAIN'}),
        'chbRspCode': new DBMappingInfo({ field: 'F_CHBRspCode', table: 'T_OIMMAIN' }),
        'chbRspMsg': new DBMappingInfo({ field: 'F_CHBRspMsg', table: 'T_OIMMAIN' }),
    };

    setChildTrackable(value: boolean): void {
        if(this.oimContainerList.length > 0) {
            this.oimContainerList.forEach(c => c.trackable = value);
        }
    }
}

